import React, { useContext } from "react";
import { Redirect } from "react-router-dom";
import { ConfigurationContext } from '../../context/ConfigurationContext'

const Container = props => {
  const { configurations } = useContext(ConfigurationContext);
  if(!configurations) return <Redirect to='/'/>;

  return (
    <div className={"pb-20 bg-bottom bg-no-repeat container-outer"}>
      <div className={"container max-w-8xl mx-auto"}>
        {props.children}
      </div>
    </div>
  );
};

export default Container;
